import React from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import ProjectItemRevisionUserDefinedFieldsModel from '../../../models/ProjectItemRevisionUserDefinedFieldsModel';
import UserDefinedFieldModel from '../../../models/UserDefinedFieldModel';
import WorkflowTaskSetProjectItemCustomFieldsModel from '../../../models/WorkflowTaskSetProjectItemCustomFieldsModel';
import { Result } from '../../../types/Result';

interface IProps {
    formData: WorkflowTaskSetProjectItemCustomFieldsModel
    onCellChange?: (value: any, rowIndex: number, dataProp?: string) => void
    serverErrors?: Result[]
}

const TaskSetProjectItemCustomFieldsView: React.FC<IProps> = ({ formData, onCellChange, serverErrors }) => {
    console.log(formData);

    function getUserDefinedField(rowData: ProjectItemRevisionUserDefinedFieldsModel, colInfo: IColInfo): UserDefinedFieldModel | undefined {
        let result

        rowData.userDefinedFieldValues.forEach((value, index) => {
            if (value.userDefinedField && value.userDefinedField.name == colInfo.title)
                result = value.userDefinedField
        })

        return result
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Item', dataProp: 'projectItemRevision.itemRevision', dataType: 'itemrevision', sort: 'asc' },
        { title: 'Item name', dataProp: 'projectItemRevision.itemRevision.item.name' },
    ];

    if (formData.fields) {
        formData.fields.map((field, index, array) => {
            colInfos.push({
                title: field.name,
                dataProp: 'userDefinedFieldValues.' + index + '.value',
                editable: true,
                sort: false,
                dataType: 'userDefinedField',
                getUserDefinedField: getUserDefinedField,
            })

        })
    }

    return (
        <div style={{ marginBottom: 20 }}>
            <DataTable key='dtWorkflowSetProjectItemCustomFields'
                name='dtWorkflowSetProjectItemCustomFields'
                colInfos={colInfos}
                tableData={formData.projectItemRevisions}
                serverErrors={serverErrors}
                onCellChange={onCellChange}
            />
        </div>
    );
}
export default TaskSetProjectItemCustomFieldsView;